import React from 'react';
import Auth from '@Services/Auth';
import { Logo } from '@els/els-react--logo';
import { Button } from '@els/els-react--button';
import LoginPageWrapper from '../Login/Components/LoginPageWrapper';

import './Logout.scss';

export default function Logout() {
  const goToLandingPage = () => {
    Auth.goToLandingPage(true);
  };

  return (
    <LoginPageWrapper className="react-page-logout-page" mainAriaLabel="Logout page">
      <div className="logout-page-form-wrapper u-els-background-color-background">
        <Logo className="elsevier-logo-logout u-els-padding-top u-els-margin-left-auto u-els-margin-right-auto u-els-display-block" />
        <h1 className="e2e-logout-page-header u-els-text-center u-els-color-text u-els-margin-top-1x1o2 u-els-font-size-h3">
          Signed out successfully
        </h1>
        <p className="logout-page__description u-els-font-size-base u-els-line-height-1o4 u-els-text-center u-els-margin-top u-els-width-full u-els-margin-bottom-1x1o2">
          By clicking the logout button your Reaxys session has been ended. You may return to the query page by clicking the hyperlink
          provided below or you may close your browser.
        </p>
        <div className="logout-page__button-container u-els-margin-top-1x1o2">
          <Button
            id="return-home-button"
            className="e2e-name-logout logout-page__button"
            type="secondary"
            fullWidth
            data-e2e="logout-page-return-home-button"
            onClick={goToLandingPage}
            aria-label="Return to Reaxys' home page">
            Return to Reaxys&apos; home page
          </Button>
        </div>
      </div>
    </LoginPageWrapper>
  );
}
